export default {"src":"https://fishbrain.com/_next/static/media/westVirginia.a9ceb8a7.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};